/**
 * 모듈 카탈로그 및 가격 규칙
 */

export const MODULE_CATALOG = {
  // CORE MODULES (핵심 모듈)
  auth: {
    id: 'auth',
    name: '회원 인증',
    nameEn: 'Authentication',
    category: 'core',
    description: '로그인, 회원가입, 비밀번호 찾기, 소셜 로그인(카카오, 네이버, 구글)',
    priceMin: 50,
    priceMax: 100,
    timelineDays: 1,
    complexity: 'medium',
    dependencies: ['db_basic'],
    icon: 'fal fa-user-lock'
  },
  admin: {
    id: 'admin',
    name: '관리자 페이지',
    nameEn: 'Admin Panel',
    category: 'core',
    description: '콘텐츠 관리, 회원 관리, 통계 대시보드',
    priceMin: 80,
    priceMax: 150,
    timelineDays: 2,
    complexity: 'medium',
    dependencies: ['auth'],
    icon: 'fal fa-cog'
  },
  push: {
    id: 'push',
    name: '푸시 알림',
    nameEn: 'Push Notifications',
    category: 'core',
    description: '앱 푸시 알림, 예약 발송, 타겟 발송',
    priceMin: 30,
    priceMax: 60,
    timelineDays: 1,
    complexity: 'low',
    dependencies: [],
    icon: 'fal fa-bell'
  },
  db_basic: {
    id: 'db_basic',
    name: '기본 데이터베이스',
    nameEn: 'Basic Database',
    category: 'core',
    description: '데이터 저장, 기본 CRUD 기능',
    priceMin: 40,
    priceMax: 80,
    timelineDays: 1,
    complexity: 'low',
    dependencies: [],
    icon: 'fal fa-database'
  },

  // OPTIONAL MODULES (선택 모듈)
  payment: {
    id: 'payment',
    name: '결제 시스템',
    nameEn: 'Payment System',
    category: 'optional',
    description: '카드결제, 간편결제, 정기결제, 환불 처리',
    priceMin: 30,
    priceMax: 100,
    timelineDays: 1,
    complexity: 'high',
    dependencies: ['auth', 'db_basic'],
    icon: 'fal fa-credit-card'
  },
  chat: {
    id: 'chat',
    name: '채팅/메시징',
    nameEn: 'Chat/Messaging',
    category: 'optional',
    description: '1:1 채팅, 그룹 채팅, 파일 전송',
    priceMin: 80,
    priceMax: 150,
    timelineDays: 2,
    complexity: 'high',
    dependencies: ['auth', 'real_time'],
    icon: 'fal fa-comments'
  },
  map: {
    id: 'map',
    name: '지도/위치 기반',
    nameEn: 'Map/Location',
    category: 'optional',
    description: '지도 표시, 위치 검색, 길찾기, 주변 검색',
    priceMin: 60,
    priceMax: 120,
    timelineDays: 1,
    complexity: 'medium',
    dependencies: [],
    icon: 'fal fa-map-marker-alt'
  },
  notification: {
    id: 'notification',
    name: '알림 시스템',
    nameEn: 'Notification System',
    category: 'optional',
    description: '인앱 알림, 이메일 알림, SMS 알림',
    priceMin: 40,
    priceMax: 80,
    timelineDays: 1,
    complexity: 'medium',
    dependencies: ['auth'],
    icon: 'fal fa-envelope'
  },
  file_upload: {
    id: 'file_upload',
    name: '파일 업로드',
    nameEn: 'File Upload',
    category: 'optional',
    description: '이미지, 문서, 동영상 업로드 및 관리',
    priceMin: 30,
    priceMax: 60,
    timelineDays: 1,
    complexity: 'low',
    dependencies: ['db_basic'],
    icon: 'fal fa-cloud-upload-alt'
  },
  search: {
    id: 'search',
    name: '검색 기능',
    nameEn: 'Search',
    category: 'optional',
    description: '전체 검색, 필터링, 자동완성',
    priceMin: 40,
    priceMax: 80,
    timelineDays: 1,
    complexity: 'medium',
    dependencies: ['db_basic'],
    icon: 'fal fa-search'
  },
  review: {
    id: 'review',
    name: '리뷰/평점',
    nameEn: 'Review/Rating',
    category: 'optional',
    description: '별점, 텍스트 리뷰, 이미지 리뷰',
    priceMin: 30,
    priceMax: 50,
    timelineDays: 1,
    complexity: 'low',
    dependencies: ['auth'],
    icon: 'fal fa-star'
  },
  booking: {
    id: 'booking',
    name: '예약 시스템',
    nameEn: 'Booking System',
    category: 'optional',
    description: '시간대 예약, 캘린더, 예약 관리',
    priceMin: 80,
    priceMax: 150,
    timelineDays: 2,
    complexity: 'high',
    dependencies: ['auth', 'notification'],
    icon: 'fal fa-calendar-check'
  },
  cart: {
    id: 'cart',
    name: '장바구니',
    nameEn: 'Shopping Cart',
    category: 'optional',
    description: '상품 담기, 수량 조절, 주문 처리',
    priceMin: 50,
    priceMax: 100,
    timelineDays: 1,
    complexity: 'medium',
    dependencies: ['auth', 'db_basic'],
    icon: 'fal fa-shopping-cart'
  },
  wishlist: {
    id: 'wishlist',
    name: '찜/북마크',
    nameEn: 'Wishlist/Bookmark',
    category: 'optional',
    description: '찜하기, 북마크, 관심 목록',
    priceMin: 20,
    priceMax: 40,
    timelineDays: 2,
    complexity: 'low',
    dependencies: ['auth'],
    icon: 'fal fa-heart'
  },
  board: {
    id: 'board',
    name: '게시판',
    nameEn: 'Bulletin Board',
    category: 'optional',
    description: '글 작성, 댓글, 첨부파일, 카테고리',
    priceMin: 30,
    priceMax: 50,
    timelineDays: 2,
    complexity: 'medium',
    dependencies: ['auth', 'db_basic'],
    icon: 'fal fa-clipboard-list'
  },

  // ADVANCED MODULES (고급 모듈)
  api_external: {
    id: 'api_external',
    name: '외부 API 연동',
    nameEn: 'External API Integration',
    category: 'advanced',
    description: '외부 서비스 연동, 데이터 동기화',
    priceMin: 50,
    priceMax: 150,
    timelineDays: 2,
    complexity: 'high',
    dependencies: [],
    icon: 'fal fa-plug'
  },
  analytics: {
    id: 'analytics',
    name: '분석/통계',
    nameEn: 'Analytics',
    category: 'advanced',
    description: '사용자 분석, 매출 통계, 대시보드',
    priceMin: 80,
    priceMax: 150,
    timelineDays: 2,
    complexity: 'high',
    dependencies: ['admin'],
    icon: 'fal fa-chart-line'
  },
  recommendation: {
    id: 'recommendation',
    name: '추천 시스템',
    nameEn: 'Recommendation',
    category: 'advanced',
    description: '개인화 추천, 관련 콘텐츠 추천',
    priceMin: 70,
    priceMax: 100,
    timelineDays: 2,
    complexity: 'high',
    dependencies: ['analytics', 'db_basic'],
    icon: 'fal fa-magic'
  },
  real_time: {
    id: 'real_time',
    name: '실시간 데이터',
    nameEn: 'Real-time Data',
    category: 'advanced',
    description: '웹소켓, 실시간 동기화',
    priceMin: 80,
    priceMax: 100,
    timelineDays: 2,
    complexity: 'high',
    dependencies: [],
    icon: 'fal fa-sync'
  },
  multi_language: {
    id: 'multi_language',
    name: '다국어 지원',
    nameEn: 'Multi-language',
    category: 'advanced',
    description: '다국어 UI, 번역 관리',
    priceMin: 50,
    priceMax: 100,
    timelineDays: 2,
    complexity: 'medium',
    dependencies: ['admin'],
    icon: 'fal fa-globe'
  },
  sso: {
    id: 'sso',
    name: '싱글사인온',
    nameEn: 'Single Sign-On',
    category: 'advanced',
    description: '통합 로그인, 기업 인증 연동',
    priceMin: 50,
    priceMax: 100,
    timelineDays: 2,
    complexity: 'high',
    dependencies: ['auth'],
    icon: 'fal fa-key'
  },
  crm: {
    id: 'crm',
    name: '고객 관리',
    nameEn: 'CRM',
    category: 'advanced',
    description: '고객 정보 관리, 세그먼트, 마케팅 연동',
    priceMin: 80,
    priceMax: 150,
    timelineDays: 3,
    complexity: 'high',
    dependencies: ['admin', 'analytics'],
    icon: 'fal fa-users'
  }
}

// 플랫폼 배율
export const PLATFORM_MULTIPLIERS = {
  app: 1.0,
  web: 0.9,
  both: 1.3,
  unsure: 1.0
}

// 복잡도 조정
export const COMPLEXITY_ADJUSTMENTS = {
  simple: { priceMultiplier: 0.5, timeMultiplier: 0.5 },
  medium: { priceMultiplier: 0.8, timeMultiplier: 0.8 },
  complex: { priceMultiplier: 1.0, timeMultiplier: 1.0 }
}

// 기본 비용 (모든 프로젝트에 포함)
export const BASE_COSTS = {
  projectSetup: { name: '프로젝트 셋업', priceMin: 10, priceMax: 50, timelineDays: 1 },
  deployment: { name: '배포 및 설정', priceMin: 20, priceMax: 30, timelineDays: 1 },
  storeSubmission: { name: '스토어 출시', priceMin: 20, priceMax: 30, timelineDays: 3 },
  testing: { name: '테스트 및 QA', priceMin: 20, priceMax: 50, timelineDays: 5 }
}

/**
 * 견적 계산 함수
 * @param {Array<string>} selectedModuleIds - 선택된 모듈 ID 배열
 * @param {string} platformType - 플랫폼 타입 (app, web, both, unsure)
 * @param {string} complexity - 복잡도 (simple, medium, complex)
 * @returns {Object} 견적 정보
 */
export function calculateEstimate(selectedModuleIds, platformType, complexity = 'medium') {
  let totalPriceMin = 0
  let totalPriceMax = 0
  let totalDays = 0
  const breakdown = []

  // 기본 비용 추가
  Object.entries(BASE_COSTS).forEach(([key, value]) => {
    totalPriceMin += value.priceMin
    totalPriceMax += value.priceMax
    totalDays += value.timelineDays
    breakdown.push({
      id: key,
      name: value.name,
      priceMin: value.priceMin,
      priceMax: value.priceMax,
      days: value.timelineDays,
      category: 'base'
    })
  })

  // 선택된 모듈 추가
  selectedModuleIds.forEach(moduleId => {
    const module = MODULE_CATALOG[moduleId]
    if (module) {
      totalPriceMin += module.priceMin
      totalPriceMax += module.priceMax
      totalDays += module.timelineDays
      breakdown.push({
        id: module.id,
        name: module.name,
        priceMin: module.priceMin,
        priceMax: module.priceMax,
        days: module.timelineDays,
        category: module.category
      })
    }
  })

  // 플랫폼 배율 적용
  const platformMultiplier = PLATFORM_MULTIPLIERS[platformType] || 1.0
  totalPriceMin = Math.round(totalPriceMin * platformMultiplier)
  totalPriceMax = Math.round(totalPriceMax * platformMultiplier)

  // 복잡도 조정 적용
  const complexityAdj = COMPLEXITY_ADJUSTMENTS[complexity]
  totalPriceMin = Math.round(totalPriceMin * complexityAdj.priceMultiplier)
  totalPriceMax = Math.round(totalPriceMax * complexityAdj.priceMultiplier)
  totalDays = Math.round(totalDays * complexityAdj.timeMultiplier)

  // 일수를 주 단위로 변환 (주 5일 근무 기준)
  const timelineWeeks = Math.ceil(totalDays / 5)

  return {
    priceMin: totalPriceMin,
    priceMax: totalPriceMax,
    totalDays,
    timelineWeeks,
    breakdown,
    platformType,
    complexity,
    platformMultiplier
  }
}

/**
 * 카테고리별 모듈 목록 가져오기
 * @returns {Object} 카테고리별 모듈 배열
 */
export function getModulesByCategory() {
  const categories = {
    core: [],
    optional: [],
    advanced: []
  }

  Object.values(MODULE_CATALOG).forEach(module => {
    if (categories[module.category]) {
      categories[module.category].push(module)
    }
  })

  return categories
}

/**
 * 모듈 ID로 모듈 정보 가져오기
 * @param {string} moduleId - 모듈 ID
 * @returns {Object|null} 모듈 정보
 */
export function getModuleById(moduleId) {
  return MODULE_CATALOG[moduleId] || null
}
